export function getCurrentUrl(pathname: string) {
  return pathname.split(/[?#]/)[0]
}

export function checkIsActive(pathname: string, url: string) {
  const current = getCurrentUrl(pathname)
  if (!current || !url) {
    return false
  }

  // Check if the url has query parameters
  const urlHasQuery = url.includes('?')
  const currentSearch = window.location.search

  if (urlHasQuery) {
    // If url has query params, check full URL match including query
    const urlPath = url.split('?')[0]
    const urlQuery = url.split('?')[1]

    // Path must match and query param must be present
    if (current === urlPath && currentSearch.includes(urlQuery)) {
      return true
    }
    return false
  }

  // For URLs without query params, also check that current URL doesn't have conflicting query
  // This prevents /invoices from being highlighted when on /invoices?tab=invoices
  if (current === url) {
    // If the menu item doesn't have query params but the current URL does,
    // don't mark as active (let the more specific item be active)
    if (currentSearch && currentSearch.includes('tab=')) {
      return false
    }
    return true
  }

  if (current.indexOf(url) > -1) {
    return true
  }

  return false
}
